import { Box, Typography, Button } from '@wishket/design-system';

import ContentContainer from './Container';

interface DefaultProps {
  onRequest: () => void;
}

const Default = ({ onRequest }: DefaultProps) => {
  return (
    <ContentContainer className="gap-5">
      <Box className="flex flex-col items-center gap-1">
        <Typography variant="body1" className="font-bold text-w-gray-900">
          오늘은 어떤 하루일까?
        </Typography>
        <Typography variant="body2" className="text-w-gray-600">
          요고가 알려주는 오늘의 운세
        </Typography>
      </Box>
      <Button
        variant="solid"
        size="sm"
        className="flex items-center gap-1"
        onClick={onRequest}
        leadingIcon="small_cat"
      >
        꾹 누르기
      </Button>
    </ContentContainer>
  );
};

export default Default;
